@if (user) {
  <div class="app-dashboard container">
    <div class="user-details">
      <app-profile-avatar
          [imageUrl]="user.imageUrl"
          [fullName]="user.user_name"
          class="profile-image"
      >
      </app-profile-avatar>
      <div class="info">
        <h1>
          Hi {{ user.user_name }}!
          <img src="assets/images/wave-hand.png" class="wave-hand-icon" />
        </h1>
        <p>Employee ID: {{ user.kiosk_id }}</p>
      </div>
      <div class="logout clickable" (click)="onHandleLogout()">
        <mat-icon
          aria-hidden="false"
          aria-label="Example home icon"
          fontIcon="arrow_back"
        ></mat-icon>
        Logout
      </div>
    </div>
    <app-details-page-loader [actionTypes]="['GET_TIMESHEET_LOGS_SUCCESS']">
      <mat-card appearance="outlined" class="timesheet-section">
        <mat-card-title>Timesheet</mat-card-title>
        <app-timesheet></app-timesheet>
      </mat-card>
      <mat-card appearance="outlined" class="timesheet-logs-section">
        <mat-card-title>Timesheet logs</mat-card-title>
        <app-timesheet-logs></app-timesheet-logs
        ></mat-card>
      </app-details-page-loader>
    </div>
  }
